import { combineReducers } from "redux";

import csrfReducer from "./csrfReducer";

export default combineReducers({
  csrf: csrfReducer
});
